import WeddingsGift from './WeddingsGift';

export default WeddingsGift;
